/* eslint-disable max-len */
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';
import payluddSubscriptionFields from '../../../fields/payluddSubscriptionFields';
import SubscriptionBadge from '@/app/modules/subscriptions/components/badge/SubscriptionBadge';
import RenderInitStatus from '@/app/modules/subscriptions/components/initStatus/RenderInitStatus';
import RenderSubscriptionDirectProvider from '@/app/modules/subscriptions/components/directProvider/RenderSubscriptionDirectProvider';
import RouteUrls from '@/app/root/enums/RouteUrls';
import Permissions from '@/app/permissions/Permissions';
import DetailsButton from '@/common-utils/components/renders/detailsButton/DetailsButton';
import POS_TERMINALS_TABS from '@/app/root/enums/tabs/PosTerminalsTabs';
import SUBSCRIPTION_AND_TERMINAL_DETAILS_TABS from '@/app/root/enums/tabs/SubscriptionAndTerminalDetailsTabs';

export const columnsPayluddSubscriptionId = 'payludd_subscription';

export const columnsPayluddSubscription = (headerPackage) => {

    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsPayluddSubscriptionId),
        // Columns
        generateColumnDefByField({
            field: payluddSubscriptionFields.POS_TERMINAL.DETAILS,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                <DetailsButton
                    pathParams={{ subscriptionId: row.original.posTerminalSubscription?.uuid }}
                    baseUrl={RouteUrls.SUBSCRIPTION_DETAILS.url}
                    urlParams={{
                        view: POS_TERMINALS_TABS.PAYLUDD_SUBSCRIPTIONS.name,
                        viewDetails: SUBSCRIPTION_AND_TERMINAL_DETAILS_TABS.DETAILS.name
                    }}
                    requiredPermissions={[Permissions.SUBSCRIPTION_READ.name]}
                />
            ),
            show: !headerPackage.selectionMode
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.POS_TERMINAL.SERIAL_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.POS_TERMINAL_SUBSCRIPTION.STATUS,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <SubscriptionBadge cellValue={cell.getValue(payluddSubscriptionFields.POS_TERMINAL_SUBSCRIPTION.STATUS.key)} row={cell.row} />
            )
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.POS_TERMINAL.LAST_CONNECTION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(payluddSubscriptionFields.POS_TERMINAL.LAST_CONNECTION_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.POS_TERMINAL.MANUFACTURER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.POS_TERMINAL.MODEL,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.POS_TERMINAL.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.PACKAGE.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.PACKAGE.CODE,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.PACKAGE.DOWNLOADED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(payluddSubscriptionFields.PACKAGE.DOWNLOADED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.PACKAGE.STATUS,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderInitStatus cellValue={cell.getValue(payluddSubscriptionFields.PACKAGE.STATUS)} />
            )
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.VERSION.PAX,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.VERSION.PAYLUDD,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.VERSION.ANDROID,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.POS_TERMINAL.DIRECT_PROVIDER,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const directProviderUuid = getObjectAttributeFromStringKey(cell.row.original,
                    generateNestedFieldAccessor(payluddSubscriptionFields.POS_TERMINAL.DIRECT_PROVIDER));
                return (
                    cell &&
                    <RenderSubscriptionDirectProvider directProviderLegalName={cell.getValue(payluddSubscriptionFields.POS_TERMINAL.DIRECT_PROVIDER.key)} directProviderUuid={directProviderUuid} />
                );
            }
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.ORGANIZATION,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.CONTRACT_ACCESS.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: payluddSubscriptionFields.CONTRACT_ACCESS.EMAIL,
            headerPackage: headerPackage
        })
    ]).filter(col => !!col);
};